import { cn } from '@/shared/utils/cn';

export const FORM_FIELD_BRAND_ORANGE = '#f15d4c';
export const FORM_FIELD_BRAND_GREEN = '#59ac59';

export { getFloatingFieldBorderClass } from './floatingLabel.utils';

export function getStackedInputClass(hasError: boolean, className?: string) {
  return cn(
    'w-full rounded border-gray-300 focus-visible:ring-offset-0',
    hasError && 'border-red-500 focus-visible:ring-red-500',
    className
  );
}

export function getStackedSelectClass(hasError: boolean, className?: string) {
  return cn(
    'flex h-10 w-full rounded-md border border-gray-300 bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
    hasError && 'border-red-500 focus-visible:ring-red-500',
    className
  );
}

export function getFloatingInputClass(hasEndAdornment: boolean, hasFooter: boolean, disabled: boolean) {
  return cn(
    'w-full border-0 bg-transparent px-[11px] pb-[7px] pt-[22px] text-base font-bold leading-6 text-black outline-none',
    hasEndAdornment && 'pr-[88px]',
    hasFooter && 'pb-[22px]',
    disabled && 'cursor-not-allowed'
  );
}

export function getFloatingSelectClass() {
  return 'w-full appearance-none border-0 bg-transparent px-[11px] pb-[7px] pt-[22px] pr-8 text-base font-bold leading-6 text-black outline-none';
}
